var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFiCheckCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_854_14163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 7.38666V8C15.3325 9.43761 14.867 10.8364 14.0062 11.9879C13.1454 13.1393 11.9355 13.9816 10.5569 14.3893C9.17829 14.7969 7.70484 14.7479 6.35631 14.2497C5.00779 13.7515 3.85644 12.8307 3.07397 11.6247C2.29151 10.4187 1.91986 8.99204 2.01445 7.55754C2.10904 6.12304 2.6648 4.75755 3.59885 3.66471C4.5329 2.57188 5.79519 1.81025 7.19746 1.49343C8.59973 1.1766 10.0668 1.32155 11.38 1.90666",
    stroke: "#05945B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3337 2.66667L8.66699 9.34L6.66699 7.34",
    stroke: "#05945B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_854_14163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFiCheckCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fi-check-circle.493895d4.svg";
export { ForwardRef as ReactComponent };